import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Button, Col, Container, Row, Table } from 'react-bootstrap';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { ring2, dotWave } from 'ldrs';
// import { BsPlusLg } from "react-icons/bs";
import { TbUserQuestion } from "react-icons/tb";
import AOS from 'aos';
import 'aos/dist/aos.css';
import "../css/globalCss.css";
import Cookies from 'js-cookie';
import {decryptData } from "../../../Auth/cryptage";




function Questions() {
    const MySwal = withReactContent(Swal);
    const [questions, setQuestions] = useState([]);
    const [filteredQuestions, setFilteredQuestions] = useState([]);
    const [loading, setLoading] = useState({
        who: '',
        status: false,
        userId: null
    });

    dotWave.register();
    ring2.register();
    useEffect(() => {
        AOS.init({ duration: 1200 });
    }, []);

    const getQuestions = async () => {
        try {
            setLoading({
                who: 'question',
                status: true,
                userId: null
            });
    
            const token = decryptData(Cookies.get('access_token'));
            const result = await axios.get('https://api.ai.easysystem.cloud/api/admin/questions', {
                headers: {
                    'X-Custom-Token': token
                },
                timeout: 10000
            });
    
            setQuestions(result.data.question);
            setFilteredQuestions(result.data.question);
        } catch (error) {
            if (error.response) {
                console.error("Server error: ", error.response.data);
                MySwal.fire({
                    title: "Error!",
                    text: error.response.data.message || "An error occurred on the server.",
                    icon: "error"
                });
            } else if (error.request) {
                console.error("Network error: ", error.request);
                MySwal.fire({
                    title: "Network Error!",
                    text: "No response received. Please check your network connection.",
                    icon: "error"
                });
            } else if (error.code === 'ECONNABORTED') {
                console.error("Timeout error: ", error.message);
                MySwal.fire({
                    title: "Timeout!",
                    text: "The request took too long. Please try again later.",
                    icon: "error"
                });
            } else {
                console.error("Unexpected error: ", error.message);
                MySwal.fire({
                    title: "Error!",
                    text: "An unexpected error occurred. Please try again.",
                    icon: "error"
                });
            }
        } finally {
            setLoading({
                who: 'question',
                status: false,
                userId: null
            });
        }
    };
    

    // const addModele = async (content, type, index) => {
    //     try {
    //         setLoading({
    //             who: 'modele',
    //             status: true,
    //             userId: index
    //         });
    //         const token = decryptData(Cookies.get('access_token'));
    //         const result = await axios.post('https://api.ai.easysystem.cloud/api/admin/create-modele', {
    //             content: content,
    //             typeQ: type
    //         }, {
    //             headers: {
    //                 'X-Custom-Token': token
    //             },
    //             timeout: 10000
    //         });
    
    //         // console.log()(result.data.message);
    //         MySwal.fire({
    //             title: "Success!",
    //             text: "Modele has been created",
    //             icon: "success"
    //         });
    //     } catch (error) {
    //         if (error.response) {
    //             console.error("Server error: ", error.response.data);
    //             MySwal.fire({
    //                 title: "Error!",
    //                 text: error.response.data.message || "An error occurred on the server.",
    //                 icon: "error"
    //             });
    //         } else if (error.request) {
    //             console.error("Network error: ", error.request);
    //             MySwal.fire({
    //                 title: "Network Error!",
    //                 text: "No response received. Please check your network connection.",
    //                 icon: "error"
    //             });
    //         } else if (error.code === 'ECONNABORTED') {
    //             console.error("Timeout error: ", error.message);
    //             MySwal.fire({
    //                 title: "Timeout!",
    //                 text: "The request took too long. Please try again later.",
    //                 icon: "error"
    //             });
    //         } else {
    //             console.error("Unexpected error: ", error.message);
    //             MySwal.fire({
    //                 title: "Error!",
    //                 text: "An unexpected error occurred. Please try again.",
    //                 icon: "error"
    //             });
    //         }
    //     } finally {
    //         setLoading({
    //             who: 'modele',
    //             status: false,
    //             userId: index
    //         });
    //     }
    // };
    
    
    const Search = (searchTerm) => {
        const lowercased = searchTerm.toLowerCase();
        const filteredData = questions.filter((question) =>
            Object.keys(question).some((key) => {
                const value = question[key];
                if (Array.isArray(value)) {
                    return value.some(item => 
                        Object.values(item).some(val => String(val).toLowerCase().includes(lowercased))
                    );
                }
                return String(value).toLowerCase().includes(lowercased);
            })
        );
    
        setFilteredQuestions(filteredData);
    };
    
    const isArrayEmpty = (arr) => !Array.isArray(arr) || arr.length === 0;

    useEffect(() => {
        getQuestions();
    }, []);

    useEffect(() => {
        document.title = "GecimmoIA - Questions";
    }, []);
    
    return (
        <Container >
            <Row data-aos="fade-left" className='my-4'>
                <Col>
                    <h1>
                        <TbUserQuestion className='mb-2 mx-2' />
                        Questions
                    </h1>
                </Col>
            </Row>
            <Row>
                <Col className='d-flex justify-content-end'>
                    <div className="containerSearch">
                        <input className="checkboxSearch" type="checkbox" />
                        <div className="mainboxSearch">
                            <div className="iconContainerSearch">
                                <svg
                                    viewBox="0 0 512 512"
                                    height="1em"
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="search_icon mb-1"
                                >
                                    <path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z" />
                                </svg>
                            </div>
                            <input
                                className="search_input"
                                placeholder="Recherche"
                                type="text"
                                onChange={(e) => Search(e.target.value)}
                            />
                        </div>
                    </div>
                </Col>
            </Row>
            <Row>
                <Table striped bordered hover responsive className="text-center align-middle custom-table">
                    <thead data-aos="fade-down" className="thead-dark">
                        <tr>
                            <th>#Id</th>
                            <th>Titre</th>
                            <th>Question</th>
                            <th>type</th>
                            <th>Utilisateur</th>
                            <th>Email</th>
                            {/* <th>Actions</th> */}
                        </tr>
                    </thead>
                    <tbody data-aos="fade-up">
                        {
                            loading.status && loading.who === "question" ?
                                (<tr>
                                    <td colSpan="7" className="text-center">
                                        <l-dot-wave
                                            size="47"
                                            speed="1"
                                            color="black"
                                        ></l-dot-wave>
                                    </td>
                                </tr>)
                                : isArrayEmpty(filteredQuestions) ? (
                                    <tr>
                                        <td colSpan="7" className="text-center">
                                            Not Found
                                        </td>
                                    </tr>
                                    ) :(
                                        filteredQuestions.map((question, index) => {
                                        return (
                                            <tr key={question.id} className='text-center'>
                                                <td>{question.id}</td>
                                                <td>{question.title}</td>
                                                <td>{question.content}</td>
                                                <td>{question.typeQ}</td>
                                                <td>{question.user.name} {question.user.prenom}</td>
                                                <td>{question.user.email}</td>
                                                {/* <td className='d-flex justify-content-around'>
                                                    <Button className='btn btn-success' onClick={() => addModele(question.content, question.typeQ, index)}>
                                                        {
                                                            loading.status && loading.who === "modele" && loading.userId === index ?
                                                                (
                                                                    <l-ring-2
                                                                        size="25"
                                                                        stroke="3"
                                                                        stroke-length="0.25"
                                                                        bg-opacity="0.1"
                                                                        speed="0.8"
                                                                        color="white"
                                                                    ></l-ring-2>
                                                                ) : (
                                                                    <BsPlusLg className='mx-2' />
                                                                )
                                                        }
                                                    </Button>
                                                </td> */}
                                            </tr>
                                        );
                                    })
                                )
                        }
                    </tbody>
                </Table>
            </Row>
        </Container>
    );
}

export default Questions;
